export default __webpack_public_path__ + "static/media/wallet-icon.fde1f1df.svg";